import React from 'react';
import CustomizedTooltips from '../components/tooltip.component';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import i18n from '../i18n';
import { CourseGroup, HistoryDish, MenuDish } from '../constants/type.constant';
import untreatedPic from '../assets/dish-dispensing-status/untreated.png';
import servingPic from '../assets/dish-dispensing-status/serving.png';
import accomplishPic from '../assets/dish-dispensing-status/accomplish.png';
import unablemakePic from '../assets/dish-dispensing-status/unablemake.png';
import stopmakingPic from '../assets/dish-dispensing-status/stopmaking.png';
import { StateManager } from '../redux/stateManager';
import _ from 'lodash';
import { IconButton } from '@material-ui/core';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart'
import { Cart2 } from '../modules/cart2/type';
import ServerShoppingCart from '../modules/server-shopping-cart';
import Store from '../redux/store';

// 订单详情列表组件
export class OrderDetailInfo extends React.Component<OrderRecordProps, OrderRecordState>{
    // 货币符号
    public currency_name: string = '€';
    public comboSelectedDishes: any[] = [];
    public containsDishes: CourseGroup[] = [];
    public isBusinessTime: boolean = Store.getState().isBusinessTime;
    constructor(props: OrderRecordProps) {
        super(props);
        this.state = {
            // 菜品状态（Null/0:未制作，1:已制作，2:已上菜，3:暂停制作，5:不可制作，新增：11:已备菜）
            imgPath: [
                {
                    url: untreatedPic,
                    name: i18n.t('order_history_page_text_no_make')
                },
                {
                    url: servingPic,
                    name: i18n.t('order_history_page_text_make_complete')
                },
                {
                    url: accomplishPic,
                    name: i18n.t('order_history_page_text_service_complete')
                },
                {
                    url: unablemakePic,
                    name: i18n.t('order_history_page_text_unable_make')
                },
                {
                    url: stopmakingPic,
                    name: i18n.t('order_history_page_text_pause_make')
                },
            ],
            // 气泡标签显示
            setToolTip: false,
            // 菜品名称气泡显示
            setTitleTip: false
        }
        this.currency_name = StateManager.getFromCache('currency_name') || '€';

    };

    /**
     * 按状态生成图标
     * @param states 状态码
     */
    public starIcon(states: any) {
        let imgWay = '' as any;
        let tipsName = '';
        const imgPath = this.state.imgPath;
        switch (states) {
            case null:
                imgWay = imgPath[0].url;
                tipsName = imgPath[0].name;
                break;
            case 0:
                imgWay = imgPath[0].url;
                tipsName = imgPath[0].name;
                break;
            case 1:
                imgWay = imgPath[1].url;
                tipsName = imgPath[1].name;
                break;
            case 2:
                imgWay = imgPath[2].url;
                tipsName = imgPath[2].name;
                break;
            case 3:
                imgWay = imgPath[4].url;
                tipsName = imgPath[4].name;
                break;
            case 5:
                imgWay = imgPath[3].url;
                tipsName = imgPath[3].name;
                break;
            case 11:
                imgWay = imgPath[1].url;
                tipsName = imgPath[1].name;
                break;
            default:
                break;
        }

        return (
            <CustomizedTooltips
                arrow
                onClose={this.handleTooltipClose}
                open={this.state.setToolTip}
                disableFocusListener
                disableTouchListener
                title={tipsName}
            >
                <img onClick={this.handleTooltipOpen} className='icon' src={imgWay} alt="" />
            </CustomizedTooltips>
        );
    }
    // 菜品图标气泡控制
    public handleTooltipClose = () => {
        this.setState({
            setToolTip: false
        })
    }
    public handleTooltipOpen = () => {
        this.setState({
            setToolTip: !this.state.setToolTip
        })
    }

    // 显示菜名2
    /**
     * 按状态生成图标
     * @param states 状态码
     */
    public showItemName(item: HistoryDish) {
        let tipsName = item.item_name2 ?? '';
        // 对接RBP菜名显示
        const showName = this.props.menuItemType ? item.menu_item_name : item.item_name2;
        return (
            <CustomizedTooltips
                arrow
                onClose={this.handleTitletipClose}
                open={this.state.setTitleTip}
                disableFocusListener
                disableTouchListener
                title={tipsName}
            >
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {showName}
                </div>
            </CustomizedTooltips>
        );
    }
    // 菜品名称气泡控制
    public handleTitletipClose = () => {
        this.setState({
            setTitleTip: false
        })
    }
    public handleTitletipOpen = () => {
        this.setState({
            setTitleTip: !this.state.setTitleTip
        })
    }

    /**
     * 菜品备注切割
     */
    public upDateDescription(condimentsDescription: string, description: string) {
        let descriptionSrc = '';
        // 切除字符串前后空格
        if (description) descriptionSrc = description.replace(/(^\s*)|(\s*$)/g, "");
        const splitScription = descriptionSrc ? descriptionSrc.split(' ') : [];
        const condimentsArr = condimentsDescription ? condimentsDescription.split(' ') : [];
        const processDescript = condimentsArr.concat(splitScription)

        return processDescript.map((element: any, index: number) => {

            return (
                <div key={index} className='descriptionInfo'>
                    <p>{element.replace(/(_)/g, " ")}</p>
                </div>
            )
        });

    }
    /**
     * 整理套餐组内的菜品
     * - 获取数量大于0的
     */
    renderSetMenuDetail() {
        let setMealDishes = _.flatMap((this.props.item.course_group || [])?.map((groupItem) => {
            return (groupItem?.course_detail || []).filter((dishItem) => (dishItem.quantity && dishItem.quantity > 0))
        }))
        return setMealDishes;
    }

    getComboGroup = (item: any) => {
        return this.props.comboDishGroup?.[`${item.item_id}#${item.order_detail_id}`] || [];
    }

    calcComboDishPrice = (item: MenuDish) => {
        let comboExcessPrice = 0;
        const comboDishGroup = this.getComboGroup(item);
        const comboSelectedDishes: any = [];
        for (let i = 0, len = comboDishGroup.length; i < len; i++) {
            const target = comboDishGroup[i];
            if (Array.isArray(target.course_detail) && target.course_detail.length) {
                target.course_detail.forEach(ele => {
                    const quantity = (item.quantity > 1 ? (Number(ele.quantity) / item.quantity) : ele.quantity)
                    _.set(ele, 'num', quantity);
                    _.set(ele, 'item_id', _.get(ele, 'menu_item_id'));
                    if (ele.quantity) {
                        comboSelectedDishes.push({
                            item_name1: ele.item_name1,
                            item_name2: ele.item_name2,
                            price: Number(quantity) * Number(ele.price),
                            item_id: _.get(ele, 'menu_item_id'),
                            quantity: ele.num,
                        });
                        comboExcessPrice += Number(quantity) * Number(ele.price);
                    }
                });
            }
        }
        this.comboSelectedDishes = comboSelectedDishes;
        this.containsDishes = comboDishGroup;
        return comboExcessPrice;
    }

    /**
     * 组合追加购物车菜品数据
     * @param cartDish 
     * @returns 
     */
    onChangeDishesCountInCart = (
        cartDish: MenuDish,
    ) => () => {
        try {
            ServerShoppingCart.updateServerCart({
                dish: cartDish.item_type === 3 ? Object.assign(cartDish, { containsDishes: this.containsDishes }) : cartDish as MenuDish,
                mathSymbol: 0,
                action: { type: 0, state: 0 }
            });
        } catch (err) {

        }
    }

    isDisableClick = (dish: MenuDish): boolean => {
        const { metaData: { r3: { nowTurn = 1, r3MaxTurn } = {} as Cart2.R3Config } = {} as Cart2.Cart } = ServerShoppingCart;
        // 营业时间到了关闭餐厅
        if (this.isBusinessTime && dish.not_joining_global_limit !== 1) return true;
        if (dish.not_joining_global_limit === 1) return false;
        return nowTurn > r3MaxTurn;
    }

    // *********************
    // View
    // *********************
    public render() {
        const { item, dishStatusType, isShowHistoryAppendBtn } = this.props;
        // const setMealDishes = this.renderSetMenuDetail()
        // 套餐菜品额外价格
        const comboDishExtraPrice = _.get(item, 'item_type') === 3 ? this.calcComboDishPrice(item as any) : 0;
        // 调味品价格
        const condimentsPrice: number = (item.condiments || []).reduce((pre, cur) => (pre + (!cur.free ? + Number(cur.actual_price) : 0)), 0);
        const isDisabled = !!_.get(item, 'disabled') || this.isDisableClick(item as any);
        // 处理调味品
        if(item.condiments && item.condiments.length > 0 && !item.condiments_description) {
            item.condiments_description = '';
            item.condiments.forEach((n => {
                // 付费调味品
                if(!n.free) {
                    item.condiments_description += `${n.item_name1} `;
                }
            }))
            item.condiments_description = item.condiments_description.trim();
        }
        item.excess_price_and_condiments_price_for_view = comboDishExtraPrice || item.excess_count || (item.condiments || []).length ?
           `Ext.${(comboDishExtraPrice + (item.quantity > 1 ? (condimentsPrice / item.quantity) : condimentsPrice)).toFixed(2)} ${this.currency_name}`
           : '';

        return (
            <div className='history-order-detail-box'>
                {
                    !!isShowHistoryAppendBtn ?
                        <IconButton
                            className='history-add-cart-btn'
                            style={{ opacity: isDisabled ? .5 : 1 }}
                            onClick={this.onChangeDishesCountInCart(item as any)}
                            disabled={isDisabled}
                        >
                            <AddShoppingCartIcon />
                        </IconButton>
                        :
                        null
                }
                <div style={{ backgroundColor: '#515780', borderRadius: 10, margin: '10px', width: 'calc(100% - 70px)' }}>
                    <div className='listDetail'>
                        {/* list Info */}
                        <div className='listDetail-infoLeft'>
                            {/* list title */}
                            <div className='leftText basisTextSize'>
                                <ClickAwayListener onClickAway={this.handleTitletipClose}>
                                    <div onClick={this.handleTitletipOpen}>
                                        {
                                            this.showItemName(item)
                                        }
                                    </div>
                                </ClickAwayListener>
                            </div>
                            {/* 套餐详情 */}
                            {item.item_type === 3 && (
                                <div className='set-meal-dishes-flex-box'>
                                    {(this.comboSelectedDishes).map((item, index) => {
                                        return (
                                            <div className='set-meal-dish-item' key={index}>
                                                <span className='dot'></span>
                                                {item.quantity && item?.quantity >= 1 ?
                                                    <span className='setmenu-quantiy-text'>
                                                        {`×${item.quantity}`}
                                                    </span>
                                                    : null}
                                                <div className='setmenu-dish-name'>{this.props.menuItemType ? item.item_name1 : item.item_name2}</div>
                                                {item?.price && item?.price > 0 ?
                                                    <span className='setmenu-extra-price-text'>
                                                        {`+`}{item.price.toFixed(2)}{this.currency_name}
                                                    </span>
                                                    : null}
                                            </div >
                                        )
                                    })}
                                </div>
                            )}
                            {/* remarks */}
                            <div className='leftText aiderText dishDescription'>
                                {
                                    this.upDateDescription(item.condiments_description, item.description)
                                }
                            </div>
                            {/* Ext.超额 */}
                            <div className='leftText basisTextSize' style={{ color: '#00CCCC' }}>{item.excess_price_and_condiments_price_for_view}</div>
                            {/* pic */}
                            <div className='leftText basisTextSize'>{`${item.product_price.toFixed(2)} ${this.currency_name}`}</div>
                        </div>

                        <div className='listDetail-infoRight' style={{ justifyContent: !!dishStatusType ? 'space-between' : 'center' }}>
                            {/* isMake */}
                            {!!dishStatusType &&
                                <div className='rightText'>
                                    <ClickAwayListener onClickAway={this.handleTooltipClose}>
                                        <div>
                                            {
                                                this.starIcon(item.is_make)
                                            }
                                        </div>
                                    </ClickAwayListener>
                                </div>}
                            {/* quantity */}
                            <div className='rightText'>
                                {
                                    this.props.isInterfaceSwitch ?
                                        `x${item.quantity}` : `x${item.count + item.excess_count}`
                                }
                            </div>
                        </div>

                    </div>
                    {/* <div className='divider'>
                    <Divider />
                </div> */}
                </div>
            </div>
        )
    }
}

// *********************
// Types
// *********************

type OrderRecordProps = {
    item: HistoryDish;
    isInterfaceSwitch: boolean;
    menuItemType?: boolean;
    // 已下单菜品状态显示  - 0否 1是
    dishStatusType: number;
    // 显示历史菜品追加按钮
    isShowHistoryAppendBtn?: boolean;
    comboDishGroup?: Record<string, CourseGroup[]>;
}
type OrderRecordState = {
    imgPath: Array<{
        url: any
        name: string
    }>
    setToolTip: boolean
    setTitleTip: boolean
}